import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

function AdminLayout() {
  const { signOut } = useAuth();

  return (
    <div style={styles.page}>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerInner}>
          <img src="/pass-logo.png" alt="PASS Profile 3.0" style={styles.logo} />
          <div style={styles.headerRight}>
            <span style={styles.adminBadge}>Admin</span>
            <button
              onClick={() => signOut('/login')}
              style={styles.signOutBtn}
              title="Sign out and return to the login screen so you can pick a different account"
            >
              Sign Out / Switch Account
            </button>
          </div>
        </div>
      </header>

      <div style={styles.body}>
        {/* Side nav */}
        <nav style={styles.sidebar}>
          <AdminNavLink to="/admin" end label="Dashboard" />
          <AdminNavLink to="/admin/users" label="Users" />
          <AdminNavLink to="/admin/create-account" label="Create Account" />
          <AdminNavLink to="/admin/coupons" label="Coupon Codes" />
          <div style={styles.navDivider}></div>
          <a href="/results" style={styles.navLink}>Client Portal</a>
        </nav>

        {/* Main content area */}
        <main style={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function AdminNavLink({ to, label, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        ...styles.navLink,
        ...(isActive ? styles.navLinkActive : {}),
      })}
    >
      {label}
    </NavLink>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  header: {
    backgroundColor: '#FFFFFF',
    borderBottom: '3px solid #2A9D8F',
    padding: '12px 24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    zIndex: 100,
  },
  headerInner: {
    maxWidth: 1400,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    height: '36px',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  adminBadge: {
    background: '#0B3D2E',
    color: 'white',
    padding: '4px 12px',
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  signOutBtn: {
    background: 'transparent',
    border: '1px solid #0B3D2E',
    color: '#0B3D2E',
    padding: '6px 14px',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
  },
  body: {
    display: 'flex',
    flex: 1,
  },
  sidebar: {
    width: 220,
    backgroundColor: '#0B3D2E',
    padding: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    flexShrink: 0,
  },
  navLink: {
    display: 'block',
    padding: '12px 24px',
    color: 'rgba(255,255,255,0.75)',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
    transition: 'all 0.15s',
  },
  navLinkActive: {
    color: '#FFFFFF',
    backgroundColor: 'rgba(42,157,143,0.3)',
    borderLeft: '3px solid #2A9D8F',
    paddingLeft: 21,
  },
  navDivider: {
    height: 1,
    backgroundColor: 'rgba(255,255,255,0.15)',
    margin: '12px 24px',
  },
  main: {
    flex: 1,
    padding: 32,
    backgroundColor: '#F8F9FA',
    overflowY: 'auto',
  },
};

export default AdminLayout;
